import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarServiceHistoryFaqs from "./component";
import { fetchFaqList } from "../car-service-history-info/actions";

const mapStateToProps = ({
    carServiceHistoryInfo: { faqList, isSsr }
}) => ({
    faqList,
    isSsr
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchFaqListConnect: fetchFaqList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceHistoryFaqs);

